import React from 'react';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Disclosure, RadioGroup, Switch} from '@headlessui/react';
import clsx from 'clsx';
import Slider from '@mui/material/Slider';
import * as R from 'ramda';
import {Link} from '@shopify/hydrogen';

//types
import type {
  FilterAction,
  FilterState,
  SantiyCollectionLevel as SanityCollectionLevel,
} from '../../types';

interface PriceRange {
  min: number;
  max: number;
}
export interface FilterOption {
  displayType: string;
  excludedValues: any[];
  filterOptionId: string;
  filterType: string;
  label: string;
  manualValues?: string[];
  position: number;
  prefix?: any;
  removeTextFilterValues: string;
  replaceTextFilterValues?: any;
  selectType: string;
  status: string;
  showMoreType?: string;
  showSearchBoxFilterMobile?: boolean;
  showSearchBoxFilterPC?: boolean;
  sortManualValues?: boolean;
  sortType: 'key-asc';
  tooltip?: any;
  valueType: string;
  values:
    | {
        doc_count: number;
        key: string;
      }[]
    | PriceRange;
}

interface Props {
  filter: {
    options: FilterOption[];
  };
  state: FilterState;
  dispatch: React.Dispatch<FilterAction>;
  refetch: any;
  relatedCollections?: SanityCollectionLevel[] | null;
  collectionId?: string;
}

export default function CollectionFilter({
  filter,
  state,
  dispatch,
  refetch,
  relatedCollections,
  collectionId,
}: Props) {
  const setVendor = (vendor: string) => {
    dispatch({type: 'FILTER_BRANDS', payload: vendor});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setSize = (size: string) => {
    dispatch({type: 'FILTER_SIZE', payload: size});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setColor = (color: string) => {
    dispatch({type: 'FILTER_COLOR', payload: color});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setStyle = (style: string) => {
    dispatch({type: 'FILTER_STYLE', payload: style});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setTag = (tag: string) => {
    dispatch({type: 'FILTER_TAGS', payload: tag});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setStockStatus = (status: string) => {
    dispatch({type: 'FILTER_STOCK_STATUS', payload: status});
    setTimeout(() => {
      refetch();
    }, 500);
  };

  const setPriceRange = (value: number[]) => {
    {
      dispatch({type: 'FILTER_PRICE_RANGE', payload: value});
      setTimeout(() => {
        refetch();
      }, 500);
    }
  };

  function FilterOption({o}: {o: FilterOption}) {
    switch (o.filterOptionId) {
      case 'pf_v_brand':
        return (
          <OptionList
            o={o}
            value={state['pf_v_brand[]']}
            setValue={setVendor}
          />
        );
      case 'pf_st_stock_status':
        return (
          <OptionList
            o={o}
            value={state['pf_st_stock_status[]']}
            setValue={setStockStatus}
          />
        );
      case 'pf_opt_size':
        return (
          <OptionList o={o} value={state['pf_opt_size[]']} setValue={setSize} />
        );
      case 'pf_t_color':
        return (
          <OptionSwatch
            o={o}
            value={state['pf_t_color[]']}
            setValue={setColor}
          />
        );
      case 'pf_t_style':
        return (
          <OptionList o={o} value={state['pf_t_style[]']} setValue={setStyle} />
        );
      case 'pf_t_tag':
        return (
          <OptionList o={o} value={state['pf_t_tag[]']} setValue={setTag} />
        );
      case 'pf_p_price':
        return (
          <OptionPriceRange
            o={o}
            value={state['pf_p_price[]']}
            setValue={setPriceRange}
          />
        );
      default:
        return <></>;
    }
  }

  return (
    <div className="mobile-menu h-full overflow-hidden overflow-y-scroll px-5 pb-20 md:px-0 md:pb-0">
      <div className="">
        <span className="md:hidden">Filtering options:</span>
        <span className="hidden md:block">Filter(s) Selected:</span>
      </div>
      <div className="grid gap-2 py-4 md:min-h-[80px]">
        {state['pf_v_brand[]'] &&
          state['pf_v_brand[]'].map((b, i) => (
            <button
              key={`brand-${i}`}
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_BRAND', payload: b})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Brand:</span>
                <span className="font-semibold">{b}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
        {state['pf_opt_size[]'] &&
          state['pf_opt_size[]'].map((s, i) => (
            <button
              key={`size-${i}`}
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_SIZE', payload: s})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Size:</span>
                <span className="font-semibold">{s}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
        {state['pf_t_color[]'] &&
          state['pf_t_color[]'].map((s, i) => (
            <button
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_COLOR', payload: s})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Colour:</span>
                <span className="font-semibold">{s}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
        {state['pf_t_style[]'] &&
          state['pf_t_style[]'].map((s, i) => (
            <button
              key={`style=${i}`}
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_STYLE', payload: s})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Style:</span>
                <span className="font-semibold">{s}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
        {state['pf_t_tag[]'] &&
          state['pf_t_tag[]'].map((s, i) => (
            <button
              key={`style=${i}`}
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_TAG', payload: s})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Tag:</span>
                <span className="font-semibold">{s}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
        {state['pf_st_stock_status[]'] &&
          state['pf_st_stock_status[]'].map((s, i) => (
            <button
              key={`style=${i}`}
              className="flex items-center justify-between"
              onClick={() => dispatch({type: 'CLEAR_STOCK_STATUS', payload: s})}
            >
              <div className="flex items-center space-x-2">
                <span className="font-light">Stock Status:</span>
                <span className="font-semibold">{s}</span>
              </div>
              <div className="w-[20px]">
                <svg
                  className="w-full"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                    fill="#2B2E2E"
                  ></path>
                </svg>
              </div>
            </button>
          ))}
      </div>
      <div className="grid gap-[26px]">
        {filter &&
          filter.options &&
          filter.options
            .filter((o: FilterOption) => o.filterOptionId !== 'pf_vp_price_old')
            .map((o: FilterOption, index: number) => {
              const hasOptions = o.values && !R.isEmpty(o.values);
              if (!hasOptions) {
                return null;
              }
              if (o.filterType === 'price') {
                const priceRange = o.values as PriceRange;
                if (priceRange.max === priceRange.min) {
                  return null;
                }
              }
              return (
                <div
                  key={`${o.filterOptionId}-${index}`}
                  className="border-b-[1px] border-solid border-black"
                >
                  <div className="md:hidden">
                    <Disclosure defaultOpen={false}>
                      {({open}) => (
                        <>
                          <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                            <div className="">{o.label}</div>
                            {open ? (
                              <svg
                                width="13"
                                height="3"
                                viewBox="0 0 13 3"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                  fill="black"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Disclosure.Button>
                          <Disclosure.Panel
                            className={clsx([
                              'text-gray-500 my-2',
                              o.values &&
                                Array.isArray(o.values) &&
                                o.values.length > 9 &&
                                'md:max-h-[400px] md:overflow-scroll',
                            ])}
                          >
                            <FilterOption o={o} />
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </div>
                  <div className="hidden md:block">
                    <Disclosure defaultOpen={true}>
                      {({open}) => (
                        <>
                          <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                            <div className="">{o.label}</div>
                            {open ? (
                              <svg
                                width="13"
                                height="3"
                                viewBox="0 0 13 3"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                  fill="black"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Disclosure.Button>
                          <Disclosure.Panel
                            className={clsx([
                              'text-gray-500 my-2',
                              o.values &&
                                Array.isArray(o.values) &&
                                o.values.length > 9 &&
                                'md:max-h-[400px] md:overflow-scroll',
                            ])}
                          >
                            <FilterOption o={o} />
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </div>
                </div>
              );
            })}

        {/* related collections */}
        <div className="border-b-[1px] border-solid border-black">
          <div className="md:hidden">
            <Disclosure defaultOpen={false}>
              {({open}) => (
                <>
                  <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                    <div className="">Related Collections</div>
                    {open ? (
                      <svg
                        width="13"
                        height="3"
                        viewBox="0 0 13 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                          fill="black"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                          fill="black"
                        />
                      </svg>
                    )}
                  </Disclosure.Button>
                  <Disclosure.Panel
                    className={clsx(['text-gray-500 my-2'])}
                  ></Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
          <div className="hidden md:block">
            <Disclosure defaultOpen={true}>
              {({open}) => (
                <>
                  <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
                    <div className="">Related Collections</div>
                    {open ? (
                      <svg
                        width="13"
                        height="3"
                        viewBox="0 0 13 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                          fill="black"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                          fill="black"
                        />
                      </svg>
                    )}
                  </Disclosure.Button>
                  <Disclosure.Panel className={clsx(['text-gray-500 my-2'])}>
                    <div className="grid gap-3">
                      {relatedCollections
                        ? relatedCollections
                            .filter(
                              (c) =>
                                c.this_collection.store.gid !== collectionId,
                            )
                            .map((c) => {
                              return (
                                <div className="" key={c._key}>
                                  <Link
                                    to={`/collections/${c.this_collection.store?.slug?.current}`}
                                    className="font-light capitalize"
                                  >
                                    {c.this_collection.store.title.toLowerCase()}
                                  </Link>
                                </div>
                              );
                            })
                        : null}
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        </div>
      </div>
    </div>
  );
}

function OptionList({
  o,
  value,
  setValue,
}: {
  o: FilterOption;
  value: string | string[];
  setValue: (value: string) => void;
}) {
  return (
    <RadioGroup value={value} onChange={setValue}>
      <div className={clsx(['grid gap-3'])}>
        {Array.isArray(o.values) &&
          o.values.map((v) => {
            return (
              <div className="" key={v.key}>
                <RadioGroup.Option
                  value={v.key}
                  className="flex cursor-pointer items-center space-x-2"
                >
                  {({checked}) => (
                    <>
                      <div className="flex h-[15px] w-[15px] items-center justify-center border-[1px] border-solid border-black p-[2px]">
                        {/* {checked && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
                          </svg>
                        )} */}
                        {value.includes(v.key) && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
                          </svg>
                        )}
                      </div>
                      <RadioGroup.Label className="cursor-pointer font-light">
                        {v.key}
                      </RadioGroup.Label>
                    </>
                  )}
                </RadioGroup.Option>
              </div>
            );
          })}
      </div>
    </RadioGroup>
  );
}

function OptionSwatch({
  o,
  value,
  setValue,
}: {
  o: FilterOption;
  value: string[] | string;
  setValue: (value: string) => void;
}) {
  return (
    <RadioGroup value={value} onChange={setValue}>
      <div className={clsx(['grid grid-cols-6 gap-2'])}>
        {o.displayType === 'swatch' &&
          Array.isArray(o.values) &&
          o.values.map((v) => {
            return (
              <div className="" key={v.key} title={v.key}>
                <RadioGroup.Option
                  value={v.key}
                  className="flex cursor-pointer items-center space-x-2"
                >
                  {({checked}) => (
                    <>
                      <div
                        className={clsx([
                          'h-[30px] w-[30px] rounded-full',
                          checked && value.includes(v.key) && 'opacity-100',
                          !checked && !value.includes(v.key) && 'opacity-25 hover:opacity-75',
                          v.key === 'RED' && 'bg-hk-red',
                          v.key === 'BLUE' && 'bg-blue-500',
                          v.key === 'GREEN' && 'bg-green-500',
                          v.key === 'YELLOW' && 'bg-yellow-500',
                          v.key === 'BLACK' && 'bg-black',
                          v.key === 'WHITE' &&
                            'border-[1px] border-black bg-white',
                          v.key === 'ORANGE' && 'bg-orange-500',
                          v.key === 'PURPLE' && 'bg-purple-500',
                          v.key === 'PINK' && 'bg-pink-500',
                          v.key === 'GREY' && 'bg-slate-500',
                          v.key === 'BEIGE' && 'bg-beige',
                          v.key === 'BROWN' && 'bg-yellow-900',
                        ])}
                        style={{
                          backgroundImage:
                            v.key === 'MULTICOLOR'
                              ? `url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/multicolor-2.png?v=1626147913)`
                              : v.key === 'GOLD'
                              ? 'url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/gold_40d68dd4-18d8-4d41-8302-28606f6bffc8.png?v=1625474230)'
                              : v.key === 'BRONZE'
                              ? 'url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/bronze_32f1ad16-7a3a-478c-b7ad-2d46c6ed1099.jpg?v=1626147165)'
                              : 'none',
                          backgroundSize: 'cover',
                        }}
                      >
                        {/* {checked && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
                          </svg>
                        )} */}
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
              </div>
            );
          })}
      </div>
    </RadioGroup>
  );
}

function OptionPriceRange({
  o,
  value,
  setValue,
}: {
  o: FilterOption;
  value: number[];
  setValue: (newValue: number[]) => void;
}) {
  const priceRangeObj = o.values as PriceRange;
  const minPrice = priceRangeObj.min;
  const maxPrice = priceRangeObj.max;

  if (minPrice === maxPrice) {
    return null;
  }

  const [priceRange, setPriceRange] = React.useState<number[]>([
    value[0],
    value[1],
  ]);

  const handleChange = (_: any, newValue: number | number[]) => {
    setPriceRange(newValue as number[]);
  };

  const commitChange = (_: any, newValue: number | number[]) => {
    setValue(newValue as number[]);
  };

  return (
    <div className="px-6">
      <div className="mb-2 flex items-center justify-between">
        <span className="">
          {value[0] || value[0] === 0 ? value[0] : priceRangeObj.min}
        </span>
        <span className="">&mdash;</span>
        <span className="">{value[1] ? value[1] : priceRangeObj.max}</span>
      </div>
      <div className="">
        <Slider
          getAriaLabel={() => 'Price range'}
          min={minPrice ?? 0}
          max={maxPrice ?? 100000}
          value={priceRange}
          onChangeCommitted={commitChange}
          onChange={handleChange}
          valueLabelDisplay="auto"
        />
      </div>

      <div className="flex items-center justify-between text-xs text-slate-400 opacity-75">
        <span className="">{minPrice}</span>
        <span className="">{maxPrice}</span>
      </div>
    </div>
  );
}
